import { useEffect } from 'react';

/**
 * 키보드가 화면 아래를 덮는 만큼을 CSS 변수 `--t-keyboard-inset` 에 적어 둡니다.
 * 화면 아래에 붙는 것들(시트·하단 버튼)이 그 값만큼 올라갑니다.
 *
 * 플랫폼 차이를 분기 없이 한 식으로 처리합니다(wiz-sso-front 의 같은 계산).
 *
 *     겹침 = innerHeight - (visualViewport.height + visualViewport.offsetTop)
 *
 *   · 안드로이드 웹뷰 — 키보드가 뜨면 화면을 통째로 밀어 올립니다(offsetTop 증가).
 *     이미 키보드 위에 있으므로 겹침은 0 이고, 아무것도 바뀌지 않습니다.
 *     (폴드 실측: innerHeight 1074, 보이는 높이 653, 밀린 양 422 → 겹침 0)
 *   · iOS(WKWebView) — 키보드가 덮기만 합니다. innerHeight 는 그대로이고 보이는
 *     높이만 줄어들어, 겹침이 곧 키보드 높이가 됩니다.
 *
 * visualViewport 가 없으면 아무것도 하지 않습니다 — CSS 의 기본값이 그대로 쓰입니다.
 */
export const useKeyboardInset = () => {
    useEffect(() => {
        const vv = window.visualViewport;
        if (!vv) return;

        const root = document.documentElement;
        let raf = 0;

        const apply = () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
                const overlap = Math.max(
                    0,
                    Math.round(window.innerHeight - (vv.height + vv.offsetTop)),
                );
                root.style.setProperty('--t-keyboard-inset', `${overlap}px`);
            });
        };

        apply();
        vv.addEventListener('resize', apply);
        // iOS 는 키보드가 오르내리는 동안 scroll 로도 알려 줍니다
        vv.addEventListener('scroll', apply);
        return () => {
            cancelAnimationFrame(raf);
            vv.removeEventListener('resize', apply);
            vv.removeEventListener('scroll', apply);
        };
    }, []);
};
